import { API } from 'api';
import { AxiosResponse } from 'axios';
import {
	ICityAliasesByProviderRequestList,
	ICityAliasesByProviderResponseList,
	ICityAliasByProviderItem,
	ICityAliasByProviderRequestCreate,
	ICityAliasByProviderRequestDelete,
	ICityAliasByProviderRequestUpdate,
} from 'types';
import { API_URL } from 'utils/enums';

class CityAliasesByProviderService {
	static getCityAliasesByProvider = async (
		reqBody: ICityAliasesByProviderRequestList
	): Promise<AxiosResponse<ICityAliasesByProviderResponseList>> => API.post(API_URL.CITY_ALIASES_BY_PROVIDER_LIST, reqBody);

	static createCityAliasByProvider = async (
		reqBody: ICityAliasByProviderRequestCreate
	): Promise<AxiosResponse<ICityAliasByProviderItem>> => API.post(API_URL.CITY_ALIASES_BY_PROVIDER_CREATE, reqBody);

	static updateCityAliasByProvider = async (
		reqBody: ICityAliasByProviderRequestUpdate
	): Promise<AxiosResponse<ICityAliasByProviderItem>> => API.post(API_URL.CITY_ALIASES_BY_PROVIDER_UPDATE, reqBody);

	static deleteCityAliasByProvider = async (
		reqBody: ICityAliasByProviderRequestDelete
	): Promise<AxiosResponse<void>> => API.delete(API_URL.CITY_ALIASES_BY_PROVIDER_DELETE, { data: reqBody });
}

export { CityAliasesByProviderService };
